export default __webpack_public_path__ + "static/media/promad.c05386dc.jpg";